import { environment as cocoaEnvironment } from './environment.cocoa';
//this is the minimal registration version of Cocoa casino
// https://cocoacasinogames.com/

export const environment = {
  ...cocoaEnvironment,
  hasMinReg: true, //this is the only difference with original
};


